var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgS2IconPolygon = function SvgS2IconPolygon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 450 450"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "s2_icon_polygon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h450v450H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#464646",
    strokeLinecap: "round",
    strokeWidth: 26,
    clipPath: "url(#s2_icon_polygon_svg__a)",
    "data-name": "Artboard \\u2013 2"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m56.313 98.718 12.542 172.854 30.892 106.747 167 33.487 110.91-83.289 16.031-179.658-56.34-90-158.2-20.667Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m56.5 100.152 31.9 98.641 181.466 30.538 124.042-79.405",
    "data-name": "Path 1030722"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.341 379.53 88.666 197.787",
    "data-name": "Path 1030723"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m266.561 412.5 3.229-183.511",
    "data-name": "Path 1030724"
  }))));
};
export default SvgS2IconPolygon;